import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from '../../utils/baseQueryFn';

const driverBlockAPI = createApi({
    reducerPath: "driverBlockAPI ",
    baseQuery,
    endpoints: (builder) => ({
        getAllDriverBlockedDates: builder.query({
            query: ({ driverId }) => ({
                url: `block-driver/admin/driver/${driverId}`,
                method: 'GET',
            }),
            transformResponse: (response) => response,
            providesTags: ["driver_block"],
        }),
        getAllDriverBlockedExpires: builder.query({
            query: ({ page, size, startDate, endDate, key }) => {
                let apiUrl = `block-driver/admin/driver-expire?page=${page}&size=${size}&startDate=${startDate}`;

                if(endDate){
                    apiUrl += `&endDate=${endDate}`;
                }

                if (key) {
                    apiUrl += `&searchKey=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["driver_block_expires"]
        }),
        addNewDriverBlockedDate: builder.mutation({
            query: (body) => ({
                url: `block-driver/admin`,
                method: "POST",
                body
            }),
            invalidatesTags: ["driver_block", "driver_block_expires"],
        }),
        updateDriverBlockedDate: builder.mutation({
            query: ({ body }) => ({
                url: `block-driver/admin/change-dates`,
                method: "PUT",
                body
            }),
            invalidatesTags: ["driver_block", "driver_block_expires"],
        }),
        deleteDriverBlockedDate: builder.mutation({
            query: (blockId) => ({
                url: `block-driver/admin/${blockId}`,
                method: "DELETE",
                body: {}
            }),
            invalidatesTags: ["driver_block", "driver_block_expires"],
        })
    }),
});

export const { 
    useGetAllDriverBlockedDatesQuery,
    useGetAllDriverBlockedExpiresQuery,
    useAddNewDriverBlockedDateMutation,
    useUpdateDriverBlockedDateMutation,
    useDeleteDriverBlockedDateMutation
} = driverBlockAPI;

export default driverBlockAPI;